import { Injectable } from "@angular/core";
import { IAppConfig } from "@webapp/core/app-config/models/app-config.models";

@Injectable({
  providedIn: "root",
})
export class AppConfigService {
  private readonly appConfig: IAppConfig;

  constructor() {
    this.appConfig = webappConfig();
  }
  get() {
    return this.appConfig;
  }
}
